import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Device } from '@twilio/voice-sdk';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { interval, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'calsoft-twillo-dialer',
  templateUrl: './twillo-dialer.component.html',
  styleUrls: ['./twillo-dialer.component.scss']
})
export class TwilloDialerComponent implements OnDestroy {


  url = '';
  sanitizedUrl = '';

  phoneNumber: string = '';
  callStatus: string = 'ℹ️ Device not initialized';
  private device?: Device;
  private connection?: any;
  currentCall: any = undefined;
  deviceConnectionStatus: string = 'Intilize';
  logs: string[] = [];
  data: any;
  isValid: boolean = false;
  errorMsg: string = '';
  inCall: boolean = false;
  // Timing fields
  callInitiatedTime: number | null = null; // when user pressed Call
  ringingStartTime: number | null = null; // when 'ringing' fired
  answeredTime: number | null = null; // when 'accept' fired
  connectedTime: number | null = null; // when media/connection established
  callStartTime: number | null = null; // when call is considered started for duration (ms)
  callDuration: number | null = null; // Duration in seconds (float)
  incomingCall: any = null; // Add this property
  // Computed durations
  ringingDuration: number | null = null; // seconds
  timeToAnswer: number | null = null; // seconds
  connectedDuration: number | null = null; // seconds
  private timerInterval: any = null;
  timerSubscription: any;
  callSid: any;

  constructor(private http: HttpClient,
    public dialogRef: MatDialogRef<TwilloDialerComponent>,
    @Inject(MAT_DIALOG_DATA) data, private router: Router

  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });
    this.data = data;
    console.log(this.data);
    this.phoneNumber = "+91" + this.data.phone;
    this.validatePhoneNumber();
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  private log(message: string) {
    console.log(message);
    this.logs.unshift(`${new Date().toLocaleTimeString()} — ${message}`);
  }

  ngOnInit() {
    this.initDevice();
  }
  private  baseUrl: string = environment.serverAPI10;
  initDevice() {
    this.http
      .get<{ token: string }>(
       `${this.baseUrl}/api/call/token?to=919384921642`
      )
      .subscribe({
        next: (res) => {
          this.device = new Device(res.token, { logLevel: "debug", });

          this.device.on('registered', () => {
            this.callStatus = '✅ Device registered';
            this.log(this.callStatus);
          });

          this.device.on('unregistered', () => {
            this.callStatus = '❌ Device unregistered';
            this.log(this.callStatus);
          });

          this.device.on('connect', (conn) => {
            this.callStatus = '🔗 Call connected';
            this.connection = conn;
            this.log(this.callStatus);
            // mark connected using unified handler
            this.markConnected('device.connect');
          });

          this.device.on('disconnect', () => {
            this.callStatus = '🔚 Call disconnected';
            this.connection = undefined;
            this.log(this.callStatus);
          });

          this.device.on('incoming', (call) => {
            this.callStatus = '📞 Incoming call...';
            this.incomingCall = call;
            this.log('Incoming call from: ' + call.parameters.From);
            // Optionally, auto-accept or show UI to accept/reject
          });

          this.device.on('error', (err) => {
            this.callStatus = '⚠️ Device error';
            this.log(`Error: ${JSON.stringify(err)}`);
            alert(JSON.stringify(err, null, 2));
          });

          this.device.on('tokenWillExpire', () => {
            this.http
              .get<{ token: string }>(
                 `${this.baseUrl}/api/call/token?to=${this.phoneNumber}`
              )
              .subscribe((newRes) => {
                this.device?.updateToken(newRes.token);
                this.log('🔄 Token refreshed');
              });
          });

          this.device.register();
          this.callStatus = '⚙️ Device initializing...';
          this.log(this.callStatus);
        },
        error: (err) => {
          this.callStatus = '❌ Failed to init device';
          this.log(`Init error: ${JSON.stringify(err)}`);
        }
      });
  }
  call() {
    if (!this.device) {
      this.callStatus = '⚠️ Initializing device...';
      this.log(this.callStatus);
      this.initDevice();
      setTimeout(() => this.call(), 1000);
      return;
    }

    if (!this.phoneNumber.trim()) {
      this.callStatus = '⚠️ Enter a phone number first';
      this.log(this.callStatus);
      return;
    }

    this.callStatus = `📞 Calling ${this.phoneNumber}...`;
    this.log(this.callStatus);

    // mark initiation time
    this.callInitiatedTime = Date.now();
    // clear previous timings
    this.ringingStartTime = null;
    this.answeredTime = null;
    this.connectedTime = null;
    this.callStartTime = null;
    this.callDuration = null;
    this.ringingDuration = null;
    this.timeToAnswer = null;
    this.connectedDuration = null;

    this.device.connect({ params: { To: this.phoneNumber } })
      .then(call => {

        this.currentCall = call;
        this.inCall = true;   // hide call, show hangup

        // const callSid = call.parameters.CallSid;
        // console.log('Call SID:', callSid);
        // Attach a generic logger for call events (helps debug missing events)
        const _events = ['ringing', 'accept', 'reject', 'disconnect', 'cancel', 'error', 'progress', 'timeout'];
        _events.forEach(ev => {
          try {
            call.on(ev as any, (arg: any) => {
              // keep logs small
              this.log(`[call event] ${ev} ${arg && arg.parameters ? JSON.stringify(arg.parameters) : ''}`);
              // If we get progress-like events, treat as connected (carrier dependent)
              if (ev === 'progress' || ev === 'accept') {
                this.markConnected(`call.event:${ev}`);
              }
            });
          } catch (e) {
            // ignore if event not supported
          }
        });

        // If Twilio doesn't emit 'ringing' (some carriers don't send early media), use a short fallback
        const ringingFallback = setTimeout(() => {
          if (!this.ringingStartTime && !this.answeredTime) {
            this.ringingStartTime = Date.now();
            this.log('Fallback: assuming ringing (no ring event received)');
          }
        }, 1000);

        call.on('ringing', (hasEarlyMedia) => {
          // this.callStatus = 'Ringing...';
          this.ringingStartTime = Date.now();
          this.log(this.callStatus);
          clearTimeout(ringingFallback);
        });

        call.on('accept', () => {

          console.log('Call parameters:', call.parameters);
          this.callSid = call.parameters.CallSid || call.parameters.call_sid;

          // this.callStatus = '🔗 Call Accepted';
          this.answeredTime = Date.now();
          if (this.callInitiatedTime) {
            this.timeToAnswer = Math.floor((this.answeredTime - this.callInitiatedTime) / 1000);
          }
          if (this.ringingStartTime && this.answeredTime) {
            this.ringingDuration = Math.floor((this.answeredTime - this.ringingStartTime) / 1000);
          }
          this.log(this.callStatus);
          this.markConnected('call.accept');
          clearTimeout(ringingFallback);
        });

        call.on('reject', () => {
          this.clearTimers();
          this.inCall = false;
          this.callStatus = 'Call was rejected';
          this.log(this.callStatus);
          this.callStartTime = null;
          this.callDuration = null;
          clearTimeout(ringingFallback);
        });

        call.on('disconnect', () => {
          this.clearTimers();
          this.inCall = false;
          this.callStatus = '🔚 Call disconnected';
          this.log(this.callStatus);
          const now = Date.now();
          if (this.callStartTime) {
            // keep fractional seconds to avoid 0s for short calls
            this.callDuration = parseFloat(((now - this.callStartTime) / 1000).toFixed(1));
            this.connectedDuration = this.callDuration;
          } else if (this.answeredTime && this.connectedTime) {
            this.connectedDuration = parseFloat(((now - (this.connectedTime || this.answeredTime)) / 1000).toFixed(1));
          } else {
            this.callDuration = null;
            this.connectedDuration = null;
          }
          this.callStartTime = null;
          clearTimeout(ringingFallback);
        });

        call.on('cancel', () => {
          this.clearTimers();
          this.inCall = false;
         // this.callStatus = 'Call was not answered';
          this.log(this.callStatus);
          this.callStartTime = null;
          this.callDuration = null;
          clearTimeout(ringingFallback);
        });

        call.on('error', (err) => {
          this.clearTimers();
          this.inCall = false;
          this.callStatus = '⚠️ Call error';
          this.log(this.callStatus);
          this.callStartTime = null;
          this.callDuration = null;
          clearTimeout(ringingFallback);
        });

      })
  }

  hangup() {
    if (this.currentCall) {
      this.log('⏹ Hangup requested');
      this.currentCall.disconnect();
      this.currentCall = undefined;
    }
  }

  private startDurationTimer() {
    this.stopDurationTimer();
    this.timerInterval = setInterval(() => {
      if (this.callStartTime) {
        this.callDuration = parseFloat(((Date.now() - this.callStartTime) / 1000).toFixed(1));
      }
    }, 200); // update 5x/sec to show fractional values
  }

  // Unified method to mark a call as connected. Accepts an optional source tag for logs.
  private markConnected(source?: string) {
    if (!this.connectedTime) {
      this.connectedTime = Date.now();
    }
    if (!this.callStartTime) {
      this.callStartTime = this.connectedTime;
    }
    this.log(`Marked connected (${source || 'unknown'})`);
    // start duration timer if not already running
    this.startDurationTimer();
  }

  private stopDurationTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  private clearTimers() {
    this.stopDurationTimer();
  }

  // Format seconds (number) into a friendly string like '1.2s' or '01:23'
  formatDuration(seconds: number | null): string {
    if (seconds == null) return '0s';
    if (seconds < 60) return `${seconds.toFixed(1)}s`;
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  }
  addDigit(digit: string) {
    this.phoneNumber = (this.phoneNumber || '') + digit;
    this.validatePhoneNumber();
  }

  backspace() {
    this.phoneNumber = (this.phoneNumber || '').slice(0, -1);
    this.validatePhoneNumber();
  }

  clearNumber() {
    this.phoneNumber = '';
  }



  keys = [
    { digit: '1', letters: '' },
    { digit: '2', letters: '' },
    { digit: '3', letters: '' },
    { digit: '4', letters: '' },
    { digit: '5', letters: '' },
    { digit: '6', letters: '' },
    { digit: '7', letters: '' },
    { digit: '8', letters: '' },
    { digit: '9', letters: '' },
    { digit: '*', letters: '' },
    { digit: '0', letters: '' },
    { digit: '#', letters: '' }
  ];

  closeDialer() {
    this.dialogRef.close();
  }
  validatePhoneNumber(): void {
    // Return early if the input is empty
    if (!this.phoneNumber) {
      this.isValid = false;
      this.errorMsg = '';
      return;
    }

    // Regex: must be +91 followed by 10 digits, first digit 6–9
    const phoneRegex = /^\+91[6-9]\d{9}$/;

    if (phoneRegex.test(this.phoneNumber)) {
      this.isValid = true;
      this.errorMsg = ''; // Valid input
    } else {
      this.isValid = false;
      if (/\D/.test(this.phoneNumber.replace('+', ''))) {
        this.errorMsg = 'Invalid input: Only numbers are allowed.';
      } else {
        this.errorMsg = 'Invalid phone number. Format: +91XXXXXXXXXX';
      }
    }
  }

  // Add these methods to accept/reject incoming calls
  acceptIncomingCall() {
    if (this.incomingCall) {
      this.incomingCall.accept();
      this.inCall = true;
      this.callStatus = '🔗 Call Connected';
      this.log('Accepted incoming call');
      // mark answered/connected times for incoming call
      this.answeredTime = Date.now();
      this.callStartTime = Date.now();
      this.connectedTime = this.callStartTime;
      this.startDurationTimer();
      this.incomingCall = null;
    }
  }

  rejectIncomingCall() {
    if (this.incomingCall) {
      this.incomingCall.reject();
      this.callStatus = '❌ Incoming call rejected';
      this.log('Rejected incoming call');
      this.incomingCall = null;
    }
  }
  formatStatus(status: string) {
    switch (status) {
      case 'queued':
        return 'Queued';
      case 'ringing':
        return 'Ringing...';
      case 'in-progress':
        return 'In-Progress';
      case 'completed':
        return 'Completed';
      default:
        return status;
    }
  }
  pollCallStatus() {
  const pollSub = interval(500).subscribe(() => {
    if (!this.callSid) {
      pollSub.unsubscribe();
      return;
    }


    this.http.get<any>(`${this.baseUrl}/api/call/status/${this.callSid}`).subscribe({
      next: (res) => {
    
        this.callStatus = this.formatStatus(res.status);

        // List of final statuses
        const finalStatuses = ['completed', 'failed', 'no-answer', 'busy', 'canceled'];

        if (finalStatuses.includes(res.status)) {
          this.inCall = false;
          this.callDuration = res.duration ? +res.duration : this.callDuration;
          pollSub.unsubscribe();
          if (this.timerSubscription) this.timerSubscription.unsubscribe();
          console.log('Call ended:', res);
        } else if (res.status === 'in-progress') {
          this.callStatus = 'In-Progress';
        }

        if (res.status === 'in-progress') {
          this.callStatus = 'In-Progress';
        }
      },
      error: (err) => console.error(err)
    });
    });
    }
  


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
